import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ResourcesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // GET ALL //
  getResourcesError() {
    const message = {
      body: 'RESOURCES_GET_ALL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createResourceSuccess() {
    const message = {
      body: 'RESOURCES_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createResourceError() {
    const message = {
      body: 'RESOURCES_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateResourceSuccess() {
    const message = {
      body: 'RESOURCES_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateResourceError(error?) {
    const message = {
      body: 'RESOURCES_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteResourceSuccess() {
    const message = {
      body: 'RESOURCES_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteResourceError() {
    const message = {
      body: 'RESOURCES_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteResourceCannotDeleteError() {
    const message = {
      body: 'RESOURCES_DELETE_CANNOT_DELETE_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE_ALLOCATION //
  createResourceAllocationSuccess() {
    const message = {
      body: 'RESOURCES_CREATE_ALLOCATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createResourceAllocationError() {
    const message = {
      body: 'RESOURCES_CREATE_ALLOCATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_ALLOCATION //
  updateResourceAllocationSuccess() {
    const message = {
      body: 'RESOURCES_UPDATE_ALLOCATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateResourceAllocationError() {
    const message = {
      body: 'RESOURCES_UPDATE_ALLOCATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  bulkUpdateResourceAllocationSuccess() {
    const message = {
      body: 'BULK_UPDATE_RESOURCES_ALLOCATIONS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  bulkUpdateResourceAllocationError() {
    const message = {
      body: 'BULK_UPDATE_RESOURCES_ALLOCATIONS_FAIL',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_ALLOCATION //
  deleteResourceAllocationSuccess() {
    const message = {
      body: 'RESOURCES_DELETE_ALLOCATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteResourceAllocationError() {
    const message = {
      body: 'RESOURCES_DELETE_ALLOCATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteResourceAllocationCannotDeleteError() {
    const message = {
      body: 'RESOURCES_DELETE_ALLOCATION_CANNOT_DELETE_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE_ALLOCATION_BINDING //
  createAllocationBindingSuccess() {
    const message = {
      body: 'RESOURCES_CREATE_ALLOCATION_BINDING_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createAllocationBindingError() {
    const message = {
      body: 'RESOURCES_CREATE_ALLOCATION_BINDING_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_ALLOCATION_BINDING //
  deleteAllocationBindingSuccess() {
    const message = {
      body: 'RESOURCES_DELETE_ALLOCATION_BINDING_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteAllocationBindingError() {
    const message = {
      body: 'RESOURCES_DELETE_ALLOCATION_BINDING_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'RESOURCES_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'RESOURCES_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPLOAD //
  uploadSuccess() {
    const message = {
      body: 'RESOURCES_UPLOAD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  uploadError() {
    const message = {
      body: 'RESOURCES_UPLOAD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  timelineNoRoutesInfo() {
    const message = {
      body: 'RESOURCES_TIMELINE_NO_ROUTES_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineNoMatchingSkillsInfo() {
    const message = {
      body: 'RESOURCES_NO_MATCHING_SKILLS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineNoMatchingAssignedInfo() {
    const message = {
      body: 'RESOURCES_NO_MATCHING_ASSIGNED_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineNoMatchingCompletedOrCanceledInfo() {
    const message = {
      body: 'RESOURCES_NO_MATCHING_COMPLETED_OR_CANCELED_INFO'
    };
    return this.bringozToastService.info(message)
  }


  timelineRouteIsBlocked() {
    const message = {
      body: 'RESOURCES_ROUTE_IS_BLOCKED_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineNoAllocationInfo() {
    const message = {
      body: 'RESOURCES_NO_ALLOCATION_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineNoScheduleInfo() {
    const message = {
      body: 'RESOURCES_NO_SCHEDULE_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineMultipleRoutesOnAllocationInfo() {
    const message = {
      body: 'RESOURCES_MULTIPLE_ROUTES_ON_ALLOCATION_INFO'
    };
    return this.bringozToastService.info(message)
  }

  timelineMultipleRoutesOnShiftInfo() {
    const message = {
      body: 'RESOURCES_MULTIPLE_ROUTES_ON_SCHEDULE_INFO'
    };
    return this.bringozToastService.info(message)
  }

  getTimelineError() {
    const message = {
      body: 'RESOURCE_GET_TIMELINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getResourceAllocationInstanceError() {
    const message = {
      body: 'RESOURCE_GET_RESOURCE_ALLOCATION_INSTANCE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getResourceActiveRoutesError() {
    const message = {
      body: 'RESOURCE_GET_RESOURCE_ACTIVE_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.resources')
  .service('resourcesAlertsService', ResourcesAlertsService);
